import { useState, useEffect } from 'react';
import { Container } from '@/components/layout/Container';
import { Card } from '@/components/ui/Card';
import { NativeSelect } from '@/components/ui/NativeSelect';
import { ProjectionChart } from '@/components/projections/ProjectionChart';
import { CompletionTimeline } from '@/components/projections/CompletionTimeline';
import { ProjectionEntity, TimeFrame } from '@/types/projections';
import { useNavigationStore } from '@/store/navigationStore';

export function Projections() {
  const [selectedEntity, setSelectedEntity] = useState<ProjectionEntity>('lists');
  const [timeframe, setTimeframe] = useState<TimeFrame>('month');
  
  const { setPageInfo } = useNavigationStore();

  // Set page title
  useEffect(() => {
    setPageInfo('Projections');
    
    return () => setPageInfo('Projections');
  }, []);


  return (
    <Container className="py-8">
      {/* Controls */}
      <Card className="p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-2">Entity Type</label>
            <NativeSelect
              value={selectedEntity}
              onChange={(e) => setSelectedEntity(e.target.value as ProjectionEntity)}
            >
              <option value="aspirations">Aspirations</option>
              <option value="goals">Goals</option>
              <option value="lists">Lists</option>
            </NativeSelect>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Timeframe</label>
            <NativeSelect
              value={timeframe}
              onChange={(e) => setTimeframe(e.target.value as TimeFrame)}
            >
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="quarter">This Quarter</option>
              <option value="year">This Year</option>
              <option value="all">All Time</option>
            </NativeSelect>
          </div>
        </div>
      </Card>


      {/* Main Chart */}
      <Card className="p-6 mb-8">
        <ProjectionChart 
          entity={selectedEntity}
          timeframe={timeframe}
          type="timeline"
        />
      </Card>

      {/* Completion Timeline */}
      <CompletionTimeline entity={selectedEntity} />
    </Container>
  );
}